// Arabic strings for the LDAP / Active Directory directory stream — DEVELOPMENT DRAFT by Claude
// (PD-011); unreviewed until decision H-10.
import type { enLdap } from './en-ldap.ts';
import type { Message } from './types.ts';
export const arLdap: { readonly [K in keyof typeof enLdap]: Message } = {
  'status.unknown': 'غير معروفة',

  // ------------------------------------------------------------ validation
  'ldap.v.plaintext': 'استخدم ldaps://‏ أو ldap://‏ مع StartTLS. لا يُسمح بـ LDAP غير المشفّر إلا إلى هذا الجهاز أثناء التطوير.',
  'ldap.v.tlsBoth': 'يُستخدم StartTLS مع عناوين ldap://‏؛ أما ldaps://‏ فمشفّر أصلًا.',
  'ldap.v.filter': 'ليس عامل تصفية بحث LDAP صالحًا.',
  'ldap.v.attribute': 'أدخل اسم سمة LDAP (أحرف وأرقام وشرطات) أو معرّف OID.',
  'ldap.v.pem': 'الصق شهادة جهة الإصدار بتنسيق PEM ‏(BEGIN CERTIFICATE … END CERTIFICATE).',
  'ldap.v.oneSecret': 'أدخل كلمة مرور الربط أو اسم سر النشر، وليس كليهما.',

  // ------------------------------------------------------------ run outcomes and errors
  'directory.unknown': 'لم يستجب الدليل في الوقت المحدد. لم يتغير شيء؛ والنتيجة غير معروفة حتى القراءة الناجحة التالية.',
  'directory.error.invalid_configuration': 'إعدادات الاتصال غير صالحة',
  'directory.error.transport_insecure': 'رُفض الاتصال غير المشفّر',
  'directory.error.tls_failed': 'فشل الاتصال الآمن (الشهادة أو TLS)',
  'directory.error.bind_failed': 'رُفض حساب الربط (تحقق من DN وكلمة المرور)',
  'directory.error.search_failed': 'رُفض البحث (تحقق من أساس البحث وعامل التصفية والصلاحيات)',
  'directory.error.size_limit': 'عدد الإدخالات أكبر من الحد المضبوط؛ لم يُطبَّق شيء',
  'directory.error.timeout': 'لم يستجب الدليل في الوقت المحدد (النتيجة غير معروفة)',

  // ------------------------------------------------------------ connection facts
  'ldap.facts': 'الاتصال',
  'ldap.f.url': 'نقطة الاتصال',
  'ldap.f.urlHint': 'ldaps://host:636‏، أو ldap://host:389‏ مع StartTLS.',
  'ldap.f.startTls': 'الترقية عبر StartTLS قبل تسجيل الدخول',
  'ldap.f.caCertificate': 'شهادة جهة إصدار الدليل (اختيارية، PEM)',
  'ldap.f.caCertificateHint': 'فقط لجهة إصدار شهادات خاصة. يُتحقق من الشهادات دائمًا.',
  'ldap.f.bindDn': 'حساب الربط (DN)',
  'ldap.f.bindPassword': 'كلمة مرور الربط',
  'ldap.f.bindPasswordHint': 'تُخزَّن مشفّرة ولا تُعرض مرة أخرى. اتركها فارغة لاستخدام اسم سر نشر بدلًا منها.',
  'ldap.f.searchBase': 'أساس البحث (DN)',
  'ldap.f.scope': 'نطاق البحث',
  'ldap.scope.sub': 'الشجرة الفرعية كاملة',
  'ldap.scope.one': 'مستوى واحد',
  'ldap.f.filter': 'عامل تصفية المستخدمين',
  'ldap.mapping': 'ربط السمات',
  'ldap.mappingHint': 'لا تُقرأ إلا السمات المذكورة هنا. اترك السمة الاختيارية فارغة لعدم قراءتها. وتستخدم مزامنة المضيفين أسماء السمات نفسها.',
  'ldap.f.attr.externalId': 'المعرّف الثابت',
  'ldap.f.attr.email': 'البريد الإلكتروني',
  'ldap.f.attr.displayName': 'الاسم المعروض',
  'ldap.f.attr.employeeId': 'رقم الموظف (اختياري)',
  'ldap.f.attr.department': 'القسم (اختياري)',
  'ldap.f.attr.title': 'المسمى الوظيفي (اختياري)',
  'ldap.f.attr.office': 'رمز موقع المكتب (اختياري)',
  'ldap.f.enabledMode': 'الحسابات المعطّلة',
  'ldap.enabled.ad_user_account_control': 'userAccountControl في Active Directory (علامة التعطيل)',
  'ldap.enabled.attribute': 'قيمة سمة',
  'ldap.enabled.none': 'لا تُقرأ (يُكتشف المغادرون عند خروجهم من نطاق البحث)',
  'ldap.f.enabledAttribute': 'السمة',
  'ldap.f.disabledValues': 'القيم التي تعني التعطيل (مفصولة بفواصل؛ فارغة = وجود السمة)',
  'ldap.f.pageSize': 'حجم الصفحة',
  'ldap.f.timeoutMs': 'المهلة لكل طلب (ملّي ثانية)',
  'ldap.transport.ldaps': 'LDAPS',
  'ldap.transport.starttls': 'StartTLS',
  'ldap.transport.plain': 'غير مشفّر (للتطوير فقط)',
  'ldap.secret.sealed': 'مخزّنة مشفّرة (الإصدار {version}، {at})',
  'ldap.secret.reference': 'سر النشر {name}',
  'ldap.secret.none': 'غير مضبوطة',
  'ldap.secret.label': 'بيانات اعتماد الربط',
  'ldap.edit': 'تعديل الاتصال',
  'ldap.editSub': 'تسري التغييرات من الاختبار أو المزامنة التالية. تُغيَّر كلمة مرور الربط بشكل منفصل.',
  'ldap.setPassword': 'ضبط كلمة مرور الربط',
  'ldap.setPasswordSub': 'تُشفَّر كلمة المرور عند التخزين، ولا تُعرض أو تُسجَّل أو تُدقَّق أبدًا، وتحل محل أي اسم سر نشر.',

  // ------------------------------------------------------------ test connection (counts only)
  'ldap.test': 'اختبار الاتصال',
  'ldap.testing': 'جارٍ الاختبار…',
  'ldap.test.lastLabel': 'آخر اختبار',
  'ldap.test.ok': 'تم تسجيل الدخول والبحث: قُرئت {sampled} من إدخالات العيّنة.',
  'ldap.test.counts': 'بمعرّف {withExternalId} · ببريد إلكتروني {withEmail} · باسم معروض {withDisplayName} · معطّلة {disabled}',
  'ldap.test.mapped': '{attribute}: {count} من {sampled}',
  'ldap.test.failed': 'فشل الاختبار: {reason}',
  'ldap.test.unknown': 'لم يستجب الدليل في الوقت المحدد: النتيجة غير معروفة.',
  'ldap.test.privacy': 'تُعرض الأعداد فقط؛ ولا تُقرأ أي أسماء أو عناوين بريد أو معرّفات.',
};
